import { render, staticRenderFns } from "./ShopifyDispatch.vue?vue&type=template&id=71494098&"
import script from "./ShopifyDispatch.vue?vue&type=script&lang=js&"
export * from "./ShopifyDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShopifyDispatch.vue"
export default component.exports